
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/[cat]",
      function () {
        return require("private-next-pages/archive/[cat]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/[cat]"])
      });
    }
  